import React from 'react';
import { CTAButton } from './CTAButton';
export const ProblemSolutionSection = () => {
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-503">
      <div className="max-w-5xl mx-auto" data-id="element-504">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-600 mb-6" data-id="element-505">
          The Problem With "Regular" Knee Sleeves
        </h2>
        <p className="text-center text-gray-700 text-lg max-w-3xl mx-auto mb-12" data-id="element-506">
          Stop struggling with uncomfortable knee sleeves that roll down, bunch
          up, and make your skin hot and sweaty
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16 items-center" data-id="element-507">
          <div className="bg-white rounded-xl overflow-hidden shadow-md" data-id="element-508">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/u2xwcnxSoCzuz9qCNSPdeV/dingyKneeSleeves.webp" alt="Dingy, worn-out knee sleeves showing discoloration and wear" className="w-full h-64 object-contain p-4" data-id="element-509" />
          </div>
          <div className="space-y-6" data-id="element-510">
            <div className="flex items-start" data-id="element-511">
              <div className="flex-shrink-0 w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mr-4" data-id="element-512">
                <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-513">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-514" />
                </svg>
              </div>
              <div data-id="element-515">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-516">
                  Very Uncomfortable
                </h3>
                <p className="text-gray-600" data-id="element-517">
                  Cheap neoprene sleeves get hot, sweaty, and cause constant
                  readjustments
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-518">
              <div className="flex-shrink-0 w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mr-4" data-id="element-519">
                <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-520">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-521" />
                </svg>
              </div>
              <div data-id="element-522">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-523">
                  Constant Roll-Down
                </h3>
                <p className="text-gray-600" data-id="element-524">
                  Most sleeves won't stay in place, especially on stairs or
                  during longer walks
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-525">
              <div className="flex-shrink-0 w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mr-4" data-id="element-526">
                <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-527">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-528" />
                </svg>
              </div>
              <div data-id="element-529">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-530">
                  Overpriced Options
                </h3>
                <p className="text-gray-600" data-id="element-531">
                  Premium medical sleeves often run $120+ per knee with the same
                  issues
                </p>
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-600 mb-8" data-id="element-532">
          Meet Ardava® Bamboo Knee Sleeve
        </h2>
        <p className="text-center text-gray-700 text-lg max-w-3xl mx-auto mb-10" data-id="element-533">
          The breathable bamboo-blend sleeve designed to feel like a second
          skin—and stay put without bulk
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-12" data-id="element-534">
          <div className="order-2 md:order-1" data-id="element-535">
            <div className="space-y-6" data-id="element-536">
              <div className="flex items-start" data-id="element-537">
                <div className="flex-shrink-0 w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mr-4" data-id="element-538">
                  <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-539">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-540" />
                  </svg>
                </div>
                <div data-id="element-541">
                  <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-542">
                    All-Day Comfort
                  </h3>
                  <p className="text-gray-600" data-id="element-543">
                    Breathable bamboo-blend keeps skin comfortable with no
                    sweating
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-544">
                <div className="flex-shrink-0 w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mr-4" data-id="element-545">
                  <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-546">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-547" />
                  </svg>
                </div>
                <div data-id="element-548">
                  <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-549">
                    Stay-Put Design
                  </h3>
                  <p className="text-gray-600" data-id="element-550">
                    Tapered cuff + micro-grip technology prevents rolling and
                    bunching
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-551">
                <div className="flex-shrink-0 w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mr-4" data-id="element-552">
                  <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-553">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-554" />
                  </svg>
                </div>
                <div data-id="element-555">
                  <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-556">
                    Affordable Quality
                  </h3>
                  <p className="text-gray-600" data-id="element-557">
                    Premium comfort at just $32.50 per sleeve when you buy a
                    pair
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2 bg-white rounded-xl overflow-hidden shadow-md" data-id="element-558">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qKecFbWb1iSX9ZFYup6GPo/banner_advertorial.webp" alt="Person wearing Ardava sleeve" className="w-full h-64 object-cover" data-id="element-559" />
          </div>
        </div>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-10 max-w-3xl mx-auto" data-id="element-560">
          <div className="flex items-center justify-center space-x-2 mb-4" data-id="element-561">
            <svg className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-562">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-563" />
            </svg>
            <p className="font-medium text-yellow-800" data-id="element-564">
              This Week Only: Introductory batch pricing is active. Ships
              Friday.
            </p>
          </div>
          <p className="text-center text-gray-700" data-id="element-565">
            <span className="font-semibold" data-id="element-566">Limited Time Offer:</span> Lock in
            your special pricing today before this batch sells out!
          </p>
        </div>
        <div className="text-center" data-id="element-567">
          <CTAButton text="Get Your Ardava Knee Sleeve — 60-Day Guarantee" data-id="element-568" />
        </div>
      </div>
    </section>;
};